import React, {useState} from 'react'
import Button from '../components/Button'
import CreateOrderScreen from '../screens/CreateOrderScreen';
import CreateCustomerFormExpanded from './CreateCustomerFormExpanded';
import CreateServiceForm from './manager/CreateServiceForm';
import CreateEmployeeForm from './manager/CreateEmployeeForm';
import { Link } from 'react-router-dom';
import {ReactComponent as PersonalAccountIcon} from '../components/svgs/personalAccountIcon.svg'
import {ReactComponent as CommercialAccountIcon} from '../components/svgs/officeWorkerIcon.svg'
import CreateCommercialCustomerForm from './manager/CreateCommercialCustomerForm';



const   CustomerHeader = ({orderTitle, orderSubtitle, showCreateOrderScreen, showCreateCustomerButton, showServicesButton, showEmployeesButton, showCustomersDropdownButton, showCommercialCustomerLink}) => {

  const [isSideOrderPageOpen, setIsSideOrderPageOpen] = useState(false); 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showSidePage, setShowSidePage] = useState(false);


  const handleOpenButtonClick = () => {
    setIsSideOrderPageOpen(true);
  };

  const handleCloseButtonClick = () => {
    setIsSideOrderPageOpen(false);
  };

  const handleCancel = () => {
    setShowSidePage(false);
  };

  const toggleCustomersDropdown = (e) => {
    
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleSidePage = () => {
    setShowSidePage(!showSidePage);
  };


  return (
    <section className='flex header-section'>
        <div className='flex flex-col'>
            <h1 className='welcome-text'>{orderTitle}</h1>
            <p className='welcome-subtitle'>{orderSubtitle}</p>
        </div>
        <section className='flex gap-8'>
          {showCreateOrderScreen && (
            <div className=''>
              <div className='header-btn-section'>
                  <Button onClick={handleOpenButtonClick} style={{backgroundColor: '#E3F4FB', color: '#529FBE'}}>Create an order</Button>
                  <div className="overlay" onClick={handleCloseButtonClick} style={{ display: isSideOrderPageOpen ? 'block' : 'none' }}></div>
                  <CreateOrderScreen isOpen={isSideOrderPageOpen} onClose={handleCloseButtonClick} />
              </div>
            </div>
          )}
            
            {showCreateCustomerButton && (
                <div className=''>
                  <div className='header-btn-section'>
                    <div className="customer-side-container">
                      {/* Button to trigger the side page */}
                      <Button onClick={toggleSidePage}>Create Customer</Button>

                      {/* Overlay behind the side page */}
                      {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                      {/* Side page itself */}
                      <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                        <div className="content">
                            <h2 className="create-order-page-title">Create Customer</h2>
                            <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                        </div>
                        {/* Your form components can go here */}
                        <CreateCustomerFormExpanded OnCancel={handleCancel}/>
                      </div>
                    </div>

                  </div>
                </div>
            )}
            

              {showServicesButton && (
                <div className=''>
                <div className='header-btn-section'>
                  <div className="customer-side-container">
                    {/* Button to trigger the side page */}
                    <Button onClick={toggleSidePage}>Create a service</Button>

                    {/* Overlay behind the side page */}
                    {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                    {/* Side page itself */}
                    <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                      <div className="content">
                          <h2 className="create-order-page-title">Add a service</h2>
                          <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                      </div>
                      {/* Your form components can go here */}
                      <CreateServiceForm OnCancel={handleCancel}/>
                    </div>
                  </div>

                </div>
              </div>
              )}

              {showEmployeesButton && (
                <div className=''>
                <div className='header-btn-section'>
                  <div className="customer-side-container">
                    {/* Button to trigger the side page */}
                    <Button onClick={toggleSidePage}>Add an Employee</Button>

                    {/* Overlay behind the side page */}
                    {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                    {/* Side page itself */}
                    <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                      <div className="content">
                          <h2 className="create-order-page-title">Add a employee</h2>
                          <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                      </div>
                      {/* Your form components can go here */}
                      <CreateEmployeeForm OnCancel={handleCancel}/>
                    </div>
                  </div>

                </div>
              </div>
              )}

              {showCustomersDropdownButton && (
                <div className="dropdown-container">
                <Button className="" onClick={toggleCustomersDropdown}>
                  Create Customers
                </Button>
                {isDropdownOpen && (
                  <div className="customers-dropdown-overlay" onClick={toggleCustomersDropdown}></div>
                )}
                {isDropdownOpen && (
                  <div className="customer-dropdown-menu">
                    {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                    {/* Side page itself */}
                    <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                      <div className="content">
                          <h2 className="create-order-page-title">Create Personal Account</h2>
                          <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                      </div>
                      {/* Your form components can go here */}
                      <CreateCustomerFormExpanded OnCancel={handleCancel}/>
                    </div>
                    <div className='flex'>
                      <PersonalAccountIcon className='mt-4'/>
                      <Link to="#" onClick={toggleSidePage} className='customers-dropdown-links'>Personal Account</Link>
                    </div>

                    {showCommercialCustomerLink && (
                      <div className=''>
                        {/* <div className='header-btn-section'> */}
                            {/* <Button style={{backgroundColor: '#E3F4FB', color: '#529FBE'}}>Create an order</Button> */}
                            

                            <div className='flex'>
                              <CommercialAccountIcon className='mt-4'/>
                              <Link to="#" onClick={handleOpenButtonClick}  className='customers-dropdown-links'>Commercial Account</Link>
                              <div className="overlay" onClick={handleCloseButtonClick} style={{ display: isSideOrderPageOpen ? 'block' : 'none' }}></div>
                            <CreateCommercialCustomerForm isOpen={isSideOrderPageOpen} onClose={handleCloseButtonClick} />
                          </div>
                        </div>
                      // </div>
                    )}
                    
                    
                  </div>
                )}
                
              </div>
              )}
      </section>
        
      
        
    </section>
  )
}

export default CustomerHeader